import { ARCHIVED_FILTERS, SEARCH_SORTS, type ArchivedFilter, type SearchSort } from './api';

export interface ComponentSearchState {
  query: string;
  typeId: string;
  packageId: string;
  valueMin: string;
  valueMax: string;
  inStock: boolean;
  archived: ArchivedFilter;
  sort: SearchSort;
  attributes: Record<string, string>;
}

export function readComponentSearch(search: URLSearchParams): ComponentSearchState {
  const typeId = search.get('component_type_id') ?? '';
  const archived = search.get('archived') as ArchivedFilter;
  const sort = search.get('sort') as SearchSort;
  const attributes = Object.fromEntries(
    (typeId ? search.getAll('attr') : []).flatMap((entry) => {
      const separator = entry.indexOf(':');
      return separator > 0 && separator < entry.length - 1
        ? [[entry.slice(0, separator), entry.slice(separator + 1)]]
        : [];
    }),
  );
  return {
    query: search.get('q') ?? '',
    typeId,
    packageId: search.get('package_id') ?? '',
    valueMin: typeId ? search.get('value_min') ?? '' : '',
    valueMax: typeId ? search.get('value_max') ?? '' : '',
    inStock: search.get('in_stock') === 'true',
    archived: ARCHIVED_FILTERS.includes(archived) ? archived : 'hide',
    sort: SEARCH_SORTS.includes(sort) ? sort : 'relevance',
    attributes,
  };
}

export function updateComponentSearch(
  search: URLSearchParams,
  patch: Partial<ComponentSearchState>,
): URLSearchParams {
  const current = readComponentSearch(search);
  const next = { ...current, ...patch };
  if (next.typeId !== current.typeId || !next.typeId) {
    next.valueMin = '';
    next.valueMax = '';
    next.attributes = {};
  }
  const result = new URLSearchParams(search);
  const values = {
    q: next.query,
    component_type_id: next.typeId,
    package_id: next.packageId,
    value_min: next.valueMin,
    value_max: next.valueMax,
    in_stock: next.inStock ? 'true' : '',
    archived: next.archived === 'hide' ? '' : next.archived,
    sort: next.sort === 'relevance' ? '' : next.sort,
  };
  for (const [key, value] of Object.entries(values)) {
    if (value) result.set(key, value);
    else result.delete(key);
  }
  result.delete('attr');
  for (const [key, value] of Object.entries(next.attributes)) {
    if (value) result.append('attr', `${key}:${value}`);
  }
  return result;
}
